import React from "react";
import {FeedbackType} from '@zxcvbn-ts/core/dist/types'
import {css} from '@emotion/react'

function PasswordScoreFeedbackComponent({feedback}: { feedback?: FeedbackType }) {
	const {warning, suggestions} = feedback || {};
	const cssContainer = css`
		margin-top: 5px;
		font-size: smaller;
	`
	if (!warning && !suggestions?.length) return null;

	return <div css={cssContainer}>
		{warning && <span>{warning}</span>}
		{suggestions && <ul>
			{suggestions.map((suggestion, index) => (
				<li key={suggestion}>{suggestion}</li>
			))}
		</ul>}

	</div>


}

export {PasswordScoreFeedbackComponent};
